import { Container, Divider, Typography } from '@mui/material';
import theme from 'theme';
import PolicySection from './components/PolicySection';
import content from './privacyPolicyContent.json';

const PrivacyPolicyView = () => (
  <Container maxWidth="md" sx={{ paddingTop: theme.spacing(4), paddingBottom: theme.spacing(6) }}>
    <Typography variant="h4" fontWeight={600}>
      {content.title}
    </Typography>
    <Divider sx={{ marginTop: theme.spacing(2) }} />
    {content.sections.map(section => (
      <PolicySection key={section.id} section={section} />
    ))}
  </Container>
);

export default PrivacyPolicyView;
